module.exports = __webpack_public_path__ + "img/hands-on.1c7ee64.jpg";